import {Box, Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {ErrorState, MainFooter, SentinelLoading} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {ServicePointCard} from './components/ServicePointCard';
import {ServicePointFilter} from './components/ServicePointFilter';
import {ServicePointsLoading} from './components/ServicePointsLoading';
import {useServicePoints} from './hooks/useServicePoints';
import {ServicePointsEmptyState} from './components/ServicePointsEmptyState';

const {description} = translations['pt-br'].privateFlow.help.ourAddresses;
const {failToLoadTitle, failToLoadDescription} = translations['pt-br'].commons;

export function ServicePoints() {
	const {
		isMobile,
		servicePoints,
		loadMore,
		isFetchingNextPage,
		isServicePointsLoading,
		ufs,
		hideFilters,
		isUfsLoading,
		isUfsError,
		isServicePointsError,
		refetchServicePoints,
		handleClearFilters,
		showEmptyState,
		hideServicePointsComponent,
	} = useServicePoints();

	return (
		<Fragment>
			{hideFilters ? null : (
				<ServicePointFilter ufs={ufs} isUfsLoading={isUfsLoading} isUfsError={isUfsError} />
			)}

			<Stack px={isMobile ? 2 : 4} py={2} maxWidth={'1200px'} gap={2}>
				<Typography variant="subheader">{description}</Typography>
				{isServicePointsLoading ? <ServicePointsLoading /> : null}

				{hideServicePointsComponent ? null : (
					<Grid container spacing={2}>
						{servicePoints.map(servicePoint => (
							<Grid
								size={{xs: 12}}
								key={`${servicePoint.nmUnidade}-${servicePoint.nuCep}`}
								display="flex">
								<ServicePointCard servicePoint={servicePoint} />
							</Grid>
						))}
					</Grid>
				)}

				{showEmptyState ? (
					<ServicePointsEmptyState handleClearFilters={handleClearFilters} />
				) : null}

				{isServicePointsError ? (
					<ErrorState
						title={failToLoadTitle}
						description={failToLoadDescription}
						handleRefresh={refetchServicePoints}
					/>
				) : null}

				<SentinelLoading
					minHeight="200px"
					showLoadingText={false}
					onVisible={loadMore}
					isLoading={isFetchingNextPage}
				/>
			</Stack>

			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
